<template>
    <v-dialog v-model="dialog" style="width: 100%;" persistent>
        
        <v-card>
            
            <v-app-bar class="mb-5 d-flex" flat color="transparent" style="justify-content: flex-end;">
                <v-btn color="error" @click="$emit('cancel')">Cancelar</v-btn>
                <v-btn color="primary" @click="$emit('exportPdf')" class="ml-3">Gerar PDF</v-btn>
            </v-app-bar>
            <!-- <v-container id="jobReferance" class="pdf-content"> -->
            <div id="conteudoPDF">
                <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                    <v-col cols="3">
                        <v-img src="@/assets/logo_delta.jpg" contain height="90" />
                    </v-col>
                    <v-col cols="9" class="text-right">
                        <h2 class="mb-0">Lista de Clientes</h2>

                        <span v-if="filters?.vendedor">
                            <strong>Vendedor: </strong>{{ filters?.vendedor || '' }}
                        </span>
                        <span v-if="filters?.segmento">
                            <strong>Segmento de Mercado: </strong>{{ filters?.segmento || '' }}
                        </span>
                    </v-col>
                </div>

                <v-card outlined class="pa-10">
                    <v-simple-table dense id="conteudoPDF">
                        <thead>
                            <tr>
                                <th>CÓD.</th>
                                <th>Nome</th>
                                <th>Vendedor</th>
                                <th>Segmento</th>
                                <th>Cidade</th>
                                <th>Estado</th>
                                <th>Telefone</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="dado in dadosTabela" :key="dado._id">
                                <td style="padding: 20px">{{ dado.codigo }}</td>
                                <td>
                                    <strong>{{ dado.razaoSocial }}</strong>
                                </td>
                                <td>{{ dado.vendedorNome }}</td>
                                <td>{{ dado.segmentoDeMercadoDescricao }}</td>
                                <td>{{ dado.entregaCidadeNome }}</td>
                                <td>{{ dado.entregaEstadoNome }}</td>
                                <td>{{ '-' }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>

                </v-card>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'RelatorioFornecedorPreview',
    props: ['isOpen', 'dadosTabela', 'filters'],
    data() {
        return {
            dialog: false
        }
    },
    watch: {
        isOpen(value){
            this.dialog = value;
        }
    },
}
</script>

<style scoped>
</style>